@tailwind base;
@tailwind components;
@tailwind utilities;


:host {
  display: block;
  --button-background-color: inherit;
  --button-background-color-hover: inherit;
  --button-text-color: inherit;
  --button-text-color-hover: inherit;
  z-index: 9997 !important;
}

.btn {
  background-color: var(--button-background-color);
  color: var(--button-text-color);
  z-index: 10000 !important;
}

.btn:hover {
  background-color: var(--button-background-color-hover);
  color: var(--button-text-color-hover);
}

.iframe-placeholder {
    /*loading-dots*/
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjQnIGhlaWdodD0nMjQnIHZpZXdCb3g9JzAgMCAyNCAyNCcgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48c3R5bGU+LnNwaW5uZXJfcU04M3thbmltYXRpb246c3Bpbm5lcl84SFFHIDEuMDVzIGluZmluaXRlfS5zcGlubmVyX29YUHJ7YW5pbWF0aW9uLWRlbGF5Oi4xc30uc3Bpbm5lcl9aVExme2FuaW1hdGlvbi1kZWxheTouMnN9QGtleWZyYW1lcyBzcGlubmVyXzhIUUd7MCUsNTcuMTQle2FuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246Y3ViaWMtYmV6aWVyKDAuMzMsLjY2LC42NiwxKTt0cmFuc2Zvcm06dHJhbnNsYXRlKDApfTI4LjU3JXthbmltYXRpb24tdGltaW5nLWZ1bmN0aW9uOmN1YmljLWJlemllcigwLjMzLDAsLjY2LC4zMyk7dHJhbnNmb3JtOnRyYW5zbGF0ZVkoLTZweCl9MTAwJXt0cmFuc2Zvcm06dHJhbnNsYXRlKDApfX08L3N0eWxlPjxjaXJjbGUgY2xhc3M9J3NwaW5uZXJfcU04MycgY3g9JzQnIGN5PScxMicgcj0nMycvPjxjaXJjbGUgY2xhc3M9J3NwaW5uZXJfcU04MyBzcGlubmVyX29YUHInIGN4PScxMicgY3k9JzEyJyByPSczJy8+PGNpcmNsZSBjbGFzcz0nc3Bpbm5lcl9xTTgzIHNwaW5uZXJfWlRMZicgY3g9JzIwJyBjeT0nMTInIHI9JzMnLz48L3N2Zz4=);
    background-repeat: no-repeat;
    background-position: center;
}

#swish-chat .modal-box {
  background-color: white;
  z-index: 10000 !important;
}
swish-chat .btn {
  position: fixed;
  right: 23px;
  bottom: 5px;
  width: 68px;
  z-index: 9997 !important;
  --button-background-color: blue;
  --button-background-color-hover: black;
  --button-text-color: white;
  --button-text-color-hover: yellow;
}
.pg-chat-input-bar {
  z-index: 9999 !important;
  height: 70px !important;
}

.pg-control {
  border-color: black !important;
  background-color: white !important;
}

/* ========== THE INLINE MODE STYLES ========== */

.inline-chat-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 640px;
  margin: 1rem auto;
}

.inline-input-bar {
  width: 100%;
  margin-top:-7px !important;
}

.pg-chat-input-bar-inline {
  margin-bottom: -51px !important;
}
.pg-chat-wrapper-inline {
  height: 86dvh !important;
}

.inline-chat-input {
  width: 100%;
  border: 2px solid #fd6d15;
  padding: 0.5rem;
  background-color: white;
  border-radius: 10px;
}

.inline-chat-expanded {
  position: relative;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  min-height: 300px;
  padding: 1rem;
}

.inline-close-btn {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: transparent;
  border: none;
  font-weight: bold;
  cursor: pointer;
}

.inline-iframe {
  width: 100%;
  height: 400px;
  border: none;
  margin-top: 1.5rem;
  background-color: #f9fafb;
}

.inline-powered {
  text-align: center;
  font-size: 0.8rem;
  margin-top: 1rem;
  color: #666;
}


/* ========== WIDGET MODE ========== */


.widget-button {
  /* pinned at bottom-right */
  position: fixed;
  bottom: 8px;
  right: 23px;
  background-color: #fd6d15 !important;
  color: #000000 !important;
  width: 65px;
  height: 40px;
  cursor: pointer;
  z-index: 9998 !important;
}

.widget-chat-window {
  position: fixed;
  bottom: 50px;
  right: 23px;
  width: 350px;
  height: 450px;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 6px;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  box-shadow: 0 8px 24px rgba(0,0,0,0.2);
}

.widget-close-btn {
  align-self: flex-end;
  background: transparent;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: #666;
}

.widget-iframe {
  flex: 1;
  border: none;
  width: 100%;
  overflow: auto;
  background: #f9fafb;
}

.widget-powered {
  font-size: 0.8rem;
  color: #666;
  height: 45px !important;
  padding-top: 17px !important;
  text-align: center;
}